import * as React from 'react'
import './styles.css'

const PrivacyPolicyEU = () => {
  return (
    <section className='privacy-policy-eu-section'>
      <div className='box'>
        <h1 className='privacy-policy-eu-title'>Privacy Policy</h1>

        <div className='privacy-policy-eu-content'>
          <p className='privacy-policy-eu-last-updated'>
            Effective Date: 12 November 2025
          </p>

          <p>
            This Privacy Policy explains how Pod Europe Ltd ("we", "us", "our") collects, uses and protects personal data when you visit or use our website and services (together, the "Services").
          </p>
          <p>
            We are committed to protecting your privacy and handling personal data in accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
          </p>

          <h2>1. Who we are</h2>
          <p>
            <strong>Data Controller:</strong> Pod Europe Ltd<br />
            <strong>Contact:</strong> request@pod.io
          </p>

          <h2>2. Personal data we collect</h2>
          <p>
            We may collect and process the following categories of personal data:
          </p>
          <ul>
            <li>Contact information (e.g. name, email address, organisation)</li>
            <li>Professional information (e.g. role, skills, experience, CVs where provided)</li>
            <li>Account information (where accounts are enabled)</li>
            <li>Usage data (e.g. pages visited, interactions with the site)</li>
            <li>Communications (e.g. enquiries, emails or messages you send us)</li>
          </ul>
          <p>
            We only collect personal data that is necessary for the purposes described in this Policy.
          </p>

          <h2>3. How we collect personal data</h2>
          <p>
            We collect personal data when you:
          </p>
          <ul>
            <li>Visit our website</li>
            <li>Contact us or submit an enquiry</li>
            <li>Upload information (such as a CV or profile details)</li>
            <li>Use our services provided to organisations (e.g. workforce or skills platforms)</li>
          </ul>
          <p>
            We may also receive limited professional data from organisations that engage us to provide services on their behalf.
          </p>

          <h2>4. How we use personal data</h2>
          <p>
            We use personal data to:
          </p>
          <ul>
            <li>Provide and operate our services</li>
            <li>Respond to enquiries and communications</li>
            <li>Support workforce, skills and capability analysis</li>
            <li>Improve our website and services</li>
            <li>Meet legal and regulatory obligations</li>
            <li>Maintain security and prevent misuse</li>
          </ul>
          <p>
            Where AI or automated tools are used, they are applied in a human-supervised and explainable manner, and decisions are not made solely by automated means.
          </p>

          <h2>5. Lawful bases for processing</h2>
          <p>
            We process personal data under one or more of the following lawful bases:
          </p>
          <ul>
            <li>Performance of a contract</li>
            <li>Legitimate interests (e.g. delivering and improving services)</li>
            <li>Consent, where required</li>
            <li>Legal obligation</li>
          </ul>
          <p>
            You may withdraw consent at any time where consent is the lawful basis.
          </p>

          <h2>6. Sharing of personal data</h2>
          <p>
            We may share personal data with:
          </p>
          <ul>
            <li>Trusted service providers acting on our instructions</li>
            <li>Organisations that engage us to deliver services on their behalf</li>
            <li>Public authorities where required by law</li>
          </ul>
          <p>
            We do not sell personal data or share it for third-party advertising purposes.
          </p>

          <h2>7. Data security</h2>
          <p>
            We implement appropriate technical and organisational measures to protect personal data, including:
          </p>
          <ul>
            <li>Secure hosting environments</li>
            <li>Encryption in transit and at rest</li>
            <li>Access controls</li>
            <li>Cyber Essentials–aligned security practices</li>
          </ul>
          <p>
            No system is completely secure, but we take reasonable steps to protect your data.
          </p>

          <h2>8. Data retention</h2>
          <p>
            We retain personal data only for as long as necessary for the purposes set out in this Policy, or as required by law. Data may be retained in anonymised or aggregated form for research and analysis.
          </p>

          <h2>9. Your rights</h2>
          <p>
            Under UK GDPR, you have rights including:
          </p>
          <ul>
            <li>Access to your personal data</li>
            <li>Correction of inaccurate data</li>
            <li>Erasure (in certain circumstances)</li>
            <li>Restriction or objection to processing</li>
            <li>Data portability</li>
            <li>Withdrawal of consent</li>
          </ul>
          <p>
            Requests can be made by contacting us at request@pod.io.
          </p>

          <h2>10. International transfers</h2>
          <p>
            Where personal data is processed outside the UK, we ensure appropriate safeguards are in place in accordance with UK GDPR requirements.
          </p>

          <h2>11. Changes to this Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
          </p>

          <h2>12. Contact us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy or how we handle personal data, please contact:
          </p>
          <p className='privacy-policy-eu-contact'>
            Email: request@pod.io
          </p>
        </div>
      </div>
    </section>
  )
}

export default PrivacyPolicyEU
